import { Textarea } from '@schuettflix/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LocationType } from '@/modules/location/domain/LocationSchema.ts';

interface LocationNotesProps {
    value?: string | null;
    onChange: (value: string) => void;
    locationType: LocationType;
}

export const LocationNotes: React.FC<LocationNotesProps> = ({ value, onChange, locationType }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-4">
            <h3 className="font-copy-md-strong">{t('location.furtherDetails.label')}</h3>
            <Textarea
                value={value ?? ''}
                onChange={e => onChange(e.target.value)}
                placeholder={t('location.notes.placeholder')}
                label={
                    locationType === 'LOADING' ? t('location.notes.label.loading') : t('location.notes.label.unloading')
                }
            />
        </div>
    );
};
